import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar";

dayjs.extend(calendar);

export function formatCalendarTime(dateString: string) {
  return dayjs(dateString).calendar(null, {
    sameDay: "[Today at] h:mm A",
    lastDay: "[Yesterday at] h:mm A",
    lastWeek: "dddd [at] h:mm A",
    sameElse: "MMMM D, YYYY [at] h:mm A",
  });
}